import React, { useState } from "react";
import "../ProductSpecificAgreement.modules.css";

import { useTranslation } from "react-i18next";
import i18next from "i18next";
import * as Constants from "../../../../../constants/Constants";

const AcceptPrivacyandCookiePolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="ProductSpecificAgreement-container">
      <div className="progress-bar"></div>
      <h2>{t("AcceptPrivacyandCookiePolicy")}</h2>
      <label>{t("cookiesreceiveservices")}</label>
      {i18next.language === "ar" ? (
        <div className="agreements-container" style={{ overflow: "auto", height: "70%" }}>
          <p>بعض ملفات تعريف الارتباط (الكوكيز) ضرورية لعمل منصتنا (لا يمكنك إلغاء الاشتراك من هذه الكوكيز إذا كنت ترغب في استخدام منصتنا).</p>

          <p>
            قد يسمح لك متصفحك أيضًا بحظر تخزين الكوكيز على جهاز الكمبيوتر الخاص بك؛ يرجى الرجوع إلى قائمة "المساعدة" في متصفحك أو موقع الويب الخاص به لمزيد من المعلومات. إذا كنت تستخدم خدماتنا عبر الإنترنت دون حظر الكوكيز، فأنت بذلك توافق على
            استخدامها.
          </p>

          <p>ملاحظة أمنية للعميل تعتبر معلوماتك الشخصية جزءًا قيمًا من حياتك المالية. نوصي بشدة بحماية معلوماتك بالطريقة نفسها التي تراقب بها حساباتك المالية.</p>

          <p>تواصل مع فريق الأمن ومكافحة الاحتيال لدينا</p>

          <p>إذا كنت بحاجة إلى الإبلاغ عن سرقة الهوية أو الاحتيال، أو إذا كانت لديك أي أسئلة، يرجى الاتصال على: 123 SIB (1234)</p>

          <p> التعديلات</p>

          <p>يتم تطبيق قوانين دولة الإمارات العربية المتحدة فقط فيما يتعلق بأي نزاعات تنشأ عن استخدام هذا الموقع. بالإضافة إلى ذلك، تكون محاكم إمارة أبوظبي هي الاختصاص الحصري للنظر في هذه النزاعات وتسويتها.</p>

          <p>نحتفظ بالحق في تعديل أجزاء من بيان الخصوصية هذا في أي وقت دون إشعار مسبق. يرجى مراجعة هذا البيان من وقت لآخر لمعرفة أي تغييرات.</p>

          {/* <div className='TAndCDiv'>
    <button className='rejectTC'>رفض</button>
    <button>قبول</button>
</div> */}
        </div>
      ) : (
        <div className="agreements-container" style={{ overflow: "auto", height: "70%" }}>
          <p>Some cookies are essential to the performance of our platform (you cannot opt out from these cookies if you wish to use our platform).</p>

          <p>
            Your browser may also allow you to block the storage of cookies on your computer; please refer to your browser's "Help" menu or website for more information. If you use our web services without blocking cookies you are actually consenting
            to the cookies..
          </p>

          <p>Security Note to The Client Your personal information is a valuable part of your financial life. We strongly recommend that you protect your information in the same way you monitor your financial accounts..</p>

          <p>Contact Our Security and Fraud Team</p>

          <p>If you need to report identity theft or fraud, or if you have questions, please call: 123 SIB (1234)</p>

          <p> Amendments</p>

          <p>
            Applicable laws of the United Arab Emirates only shall be implemented in connection to any disputes arising from using this website. In addition, courts of the Emirates of Abu Dhabi shall be the exclusive jurisdiction to consider and
            settle such disputes.
          </p>

          <p> We reserve the right to modify sections of this Privacy Statement at any time without notice. Please check this statement from time to time for any changes.</p>

          {/* <div className='TAndCDiv'>
    <button className='rejectTC'>Reject</button>
    <button >Accept</button>
</div> */}
        </div>
      )}
    </div>
  );
};

export default AcceptPrivacyandCookiePolicy;
